import axios from "axios";

import { BASE_URL } from "./../../../constants";
export const PRODUCTS_URL = "api/churches";

// CREATE =>  POST: add a new church to the server
export async function createChurch(church) {
  const obrazecPromise = axios.post(
    `${BASE_URL}/private/createObrazec`,
    church
  );

  const obrazecResult = await obrazecPromise;

  const data = new FormData();

  try {
    // add all images
    data.append("obrazecId", obrazecResult.data.obrazec.id);

    for (let i = 0; i < church.files.length; i++) {
      data.append("images", church.files[i], church.files[i].name);
    }

    await axios.post(`${BASE_URL}/createObrazecImages`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  } catch (e) {
    console.log(e);
  }
  return obrazecPromise;
}

// READ
export function getAllChurches(queryParams) {
  return axios.post(`${BASE_URL}/public/getAllObrasci`, {
    search: queryParams,
  });
}

export function getObrazecById(id) {
  return axios.post(`${BASE_URL}/public/getObrazecById`, { id });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findChurches(queryParams) {
  return axios.post(`${PRODUCTS_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the procuct on the server
export async function updateObrazec(church) {
  const obrazecPromise = axios.put(
    `${BASE_URL}/private/updateObrazecById`,
    church
  );
  const obrazecResult = await obrazecPromise;
  const data = new FormData();

  // add all images
  data.append("obrazecId", obrazecResult.data.obrazec.id);

  for (let i = 0; i < church.files.length; i++) {
    data.append("images", church.files[i], church.files[i].name);
  }

  await axios.post(`${BASE_URL}/createObrazecImages`, data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });

  return obrazecPromise;
}

// UPDATE Status
export function updateStatusForChurches(ids, status) {
  return axios.post(`${PRODUCTS_URL}/updateStatusForChurches`, {
    ids,
    status,
  });
}

// DELETE => delete the church from the server
export function deleteChurch(id) {
  return axios.post(`${BASE_URL}/private/deleteObrazecById`, { id });
}

// DELETE Churches by ids
export function deleteChurches(ids) {
  return axios.post(`${PRODUCTS_URL}/deleteChurches`, { ids });
}
